export enum BusinessUnit {
  'Glam' = 1,
  'Mens' = 2
}
